import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
  faPowerOff,
  faTrash,
  faPlusCircle,
  faSearch,
  faArrowLeft,
  faBars,
  faQuestionCircle,
  faSpinner,
  faSort,
  faEye,
  faPencilAlt,
  faMinus,
  faHome,
} from '@fortawesome/free-solid-svg-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';

import {
  ModalLogoutComponent,
  ContentHeaderComponent,
  ContentListComponent,
  ModalConfirmComponent,
  LoadingComponent,
  LoadingGlobalComponent,
} from './components';

import {
  AppExpandMenu,
  AppExpandSidebar,
  FilterGeneralPipe,
  SearchPipe,
  OrderByPipe,
} from './pipes';
import { ComboBoxLoadingComponent } from './components/combo-box-loading/combo-box-loading.component';
import { TranslateModule } from '@ngx-translate/core';
import { HistoricComponent } from './components/historic/historic.component';
import { ActivePlansComponent } from './components/active-plans/active-plans.component';
import { ProblemDefinitionComponent } from './components/problem-definition/problem-definition.component';
import { MembersComponent } from './components/members/members.component';
import { AnalisisComponent } from './components/analisis/analisis.component';
import { PlanDevelopmentComponent } from './components/plan-development/plan-development.component';
import { PlanStatisticsComponent } from './components/plan-statistics/plan-statistics.component';
import { ResourceSummaryComponent } from './components/resource-summary/resource-summary.component';
import { ActionFormComponent } from './components/action-form/action-form.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HistoricDetailsComponent } from './components/historic-details/historic-details.component';
import { HistoryComponent } from './components/modal/history/history.component';
import { ConfigurationComponent } from './components/modal/configuration/configuration.component';
import { MembersModalComponent } from './components/modal/members-modal/members-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalActionComponent } from './components/modal/modal-action/modal-action.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HorizontalChartComponent } from './components/graphs/horizontal-chart/horizontal-chart.component';
import { PieChartComponent } from './components/graphs/pie-chart/pie-chart.component';
import { ButtonInformeComponent } from './components/button-informe/button-informe.component';
import { SieniModModule } from 'sieni-diagrams-module';
import { MethodsComponent } from './components/modal/methods/methods.component';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxPaginationModule,
    TranslateModule,
    MatExpansionModule,
    MatGridListModule,
    NgxChartsModule,
    MatAutocompleteModule,
    BsDatepickerModule,
    NgMultiSelectDropDownModule,
    SieniModModule,
  ],
  declarations: [
    ModalLogoutComponent,
    AppExpandMenu,
    AppExpandSidebar,
    ContentHeaderComponent,
    ContentListComponent,
    FilterGeneralPipe,
    SearchPipe,
    ModalConfirmComponent,
    OrderByPipe,
    LoadingComponent,
    LoadingGlobalComponent,
    ComboBoxLoadingComponent,
    ActivePlansComponent,
    ProblemDefinitionComponent,
    MembersComponent,
    AnalisisComponent,
    PlanDevelopmentComponent,
    PlanStatisticsComponent,
    ResourceSummaryComponent,
    ActionFormComponent,
    HistoricDetailsComponent,
    HistoryComponent,
    ConfigurationComponent,
    MembersModalComponent,
    ModalActionComponent,
    HorizontalChartComponent,
    PieChartComponent,
    ButtonInformeComponent,
    MethodsComponent,
  ],
  exports: [
    ModalLogoutComponent,
    AppExpandMenu,
    AppExpandSidebar,
    ContentHeaderComponent,
    ContentListComponent,
    FilterGeneralPipe,
    SearchPipe,
    ModalConfirmComponent,
    OrderByPipe,
    LoadingComponent,
    LoadingGlobalComponent,
    ActivePlansComponent,
    ProblemDefinitionComponent,
    MembersComponent,
    AnalisisComponent,
    PlanDevelopmentComponent,
    PlanStatisticsComponent,
    ResourceSummaryComponent,
    ActionFormComponent,
    HistoricDetailsComponent,
    ButtonInformeComponent,
  ],
  entryComponents: [ModalLogoutComponent, ModalConfirmComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faPowerOff,
      faTrash,
      faPlusCircle,
      faSearch,
      faArrowLeft,
      faBars,
      faQuestionCircle,
      faSpinner,
      faSort,
      faEye,
      faPencilAlt,
      faMinus,
      faHome
    );
  }
}
